import { z } from 'zod';

export const UserRoleSchema = z.enum([
  'PLATFORM_ADMIN',
  'PROVIDER_OPERATOR',
  'CLIENT_ADMIN',
  'CLIENT_VIEWER',
  'BRANCH_MANAGER',
  'SAFE_OPERATOR',
  'DEVELOPER',
]);

export type UserRole = z.infer<typeof UserRoleSchema>;

export const ROLE_LABELS: Record<UserRole, string> = {
  PLATFORM_ADMIN: 'Platform Admin',
  PROVIDER_OPERATOR: 'Operador',
  CLIENT_ADMIN: 'Cliente Admin',
  CLIENT_VIEWER: 'Cliente Viewer',
  BRANCH_MANAGER: 'Gerente de Filial',
  SAFE_OPERATOR: 'Operador de Cofre',
  DEVELOPER: 'Developer',
};

export const PORTAL_ROLES: UserRole[] = [
  'PLATFORM_ADMIN',
  'PROVIDER_OPERATOR',
  'CLIENT_ADMIN',
  'CLIENT_VIEWER',
  'BRANCH_MANAGER',
  'DEVELOPER',
];

export const KIOSK_ROLES: UserRole[] = ['SAFE_OPERATOR', 'BRANCH_MANAGER'];

export const COGNITO_GROUP: Record<UserRole, string> = {
  PLATFORM_ADMIN: 'platform-admin',
  PROVIDER_OPERATOR: 'provider-operator',
  CLIENT_ADMIN: 'client-admin',
  CLIENT_VIEWER: 'client-viewer',
  BRANCH_MANAGER: 'branch-manager',
  SAFE_OPERATOR: 'safe-operator',
  DEVELOPER: 'developer',
};
